import React, { useEffect, useState } from "react";
import { Row, Col, Input, Button } from "antd";
import "../Dashboard/Dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  getTwilioTokenSubscriptionTopic,
  getTwilioTokenPublishTopic,
  getTwilioJoinRoomPublishTopic,
  getTwilioLeaveRoomPublishTopic,
  getPageSubscriptionTopic,
  getPageRequestPublishTopic
} from "hooks/MQTTConstants";
import App from "./SSVideo/App/App";
import { RootState } from "reducers/rootReducer";
import {SocketTopics} from "../../constants/enums"
import useLocalStorageService from "../../services/localStorage"

import {RID, UUID} from "../../constants/localStoreKeys"

interface IVideo {
  socket: ISocket
}

export default ({socket}: IVideo) => {
  const { searchResult, selectedItem, twilioToken } = useSelector(
    (state: RootState) => state.search
  );

  const {getLocalStorageItem} = useLocalStorageService();
  const { pageId } = useParams<{ pageId?: string }>();
  const [roomName, setRoomName] = useState(
    selectedItem?.persistent?.static?.metadata?.title ?? ""
  );


  useEffect(() => {
    console.log(twilioToken);
    if (twilioToken) {
    }
  }, [twilioToken]);


  useEffect(() => {
    if (selectedItem) {
      const selectedPage = searchResult.find((obj) => obj.pageId === +pageId);
      if (selectedPage) {
        setRoomName(selectedPage.persistent?.static?.metadata?.title ?? "");
      }
    }
  }, [selectedItem]);

  useEffect(() => {
    if (socket.client) {

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getPageSubscriptionTopic()
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getPageRequestPublishTopic(),
      {
        id: pageId,
        data: {
          objectId: pageId,
          paths: ["$"],
          returnPaths: ["$"],
          resultType: "value",
        },
      }
    );

     socket.subscribeToEvent(SocketTopics.SubscribePageTopics,  getTwilioTokenSubscriptionTopic() )


     socket.publishToEvent(SocketTopics.PublishPageTopics,getTwilioTokenPublishTopic(), {
       deviceId: getLocalStorageItem(UUID),
       identity: getLocalStorageItem(RID)
     });

    }
  }, [socket.client]);

  const handleRoomJoin = (roomSid) => {
    socket.publishToEvent(SocketTopics.PublishPageTopics,getTwilioJoinRoomPublishTopic(), {
      pageId,
      roomId: roomSid,
      userId: getLocalStorageItem(RID),
    });
  };

  const handleRoomLeave = () => {
    socket.publishToEvent(SocketTopics.PublishPageTopics, getTwilioLeaveRoomPublishTopic(), {
      pageId,
      userId: getLocalStorageItem(RID),
    });
  };

  return (
    <Row className="main-layout">
      <Col md={24} xs={24} className={"active-screen"}>
        {twilioToken && (
          <App
            onRoomJoin={handleRoomJoin}
            onRoomLeave={handleRoomLeave}
            pageId={pageId}
            pageTitle={roomName}
            token={twilioToken}
          />
        )}
      </Col>
    </Row>
  );
};
